import Button from "@/Components/Button/Button";
import { useSetModal } from "@/shared/atoms/useModal";
import { useCart, useCartQuantity } from "@/shared/hooks/useCartHook";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import KioskCartItem from "./KioskCartItem";

const KioskBasket = () => {
  const setModal = useSetModal();
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation("");
  const cartQuantity = useCartQuantity();
  const [cart] = useCart();
  return (
    <div
      onClick={() =>
        setModal("kioskCheckout", {
          id,
        })
      }
      className="flex cursor-pointer items-center gap-4  bg-(--footer_background_color) text-(--footer_text_color)  p-5"
      style={{ gridArea: "bottom" }}
    >
      <div className="kiosk-scroll-hidden min-w-0 flex-1 overflow-x-auto overflow-y-hidden">
        <div
          className="flex w-max items-center gap-4 py-4"
          id="kiosk-cart"
          style={{ position: "relative" }}
        >
          {[...cart].reverse().map((item, index) => (
            <div
              className="shrink-0"
              key={`${item.item_id}-${cart.length - 1 - index}`}
            >
              <KioskCartItem
                textCentered={true}
                imgWidth="7rem"
                onlyName={true}
                mb={"0"}
                showCounter={false}
                index={cart.length - 1 - index}
                cartItem={item}
                showEdit={false}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="ml-auto shrink-0 pl-20">
        <Button isDisabled={cartQuantity === 0} size="large">
          <div className="text-[2.5rem]">{t("seeOrderAndPay")}</div>
        </Button>
      </div>
    </div>
  );
};

export default KioskBasket;
